import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import type { ButtonGroupFilterProps } from '@/types/searchSide';
const ClearButton: React.FC<{
  onClear: () => void;
  count: number;
}> = t0 => {
  const $ = _c(7);
  const {
    onClear,
    count
  } = t0;
  const t1 = `Clear ${count} selected options`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className="t-w-3.5 t-h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== count) {
    t3 = <span>Clear {count}</span>;
    $[1] = count;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClear || $[4] !== t1 || $[5] !== t3) {
    t4 = <button type="button" className="t-inline-flex t-items-center t-gap-1 t-text-xs t-font-semibold t-text-automotive-primary hover:t-text-automotive-secondary t-transition-colors focus:t-outline-none focus:t-ring-2 focus:t-ring-automotive-primary focus:t-ring-offset-2 t-rounded-none" onClick={onClear} aria-label={t1}>{t2}{t3}</button>;
    $[3] = onClear;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const ButtonGroupFilter: React.FC<ButtonGroupFilterProps & {
  isOpen: boolean;
  onToggle: () => void;
}> = t0 => {
  const $ = _c(40);
  const {
    title,
    options,
    selectedValues,
    onChange,
    onClear,
    filterType: t1,
    isOpen,
    onToggle,
    className: t2,
    "aria-label": ariaLabel
  } = t0;
  const filterType = t1 === undefined ? "default" : t1;
  const className = t2 === undefined ? "" : t2;
  const sectionId = useId();
  let t3;
  if ($[0] !== title) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /\s+/g;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    t3 = title.toLowerCase().replace(t4, "-");
    $[0] = title;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const sectionSlug = t3;
  const triggerId = `${sectionSlug}-${sectionId}-trigger`;
  const optionsId = `${sectionSlug}-${sectionId}-options`;
  let t4;
  if ($[3] !== onChange || $[4] !== selectedValues) {
    t4 = value => {
      const isSelected = selectedValues.includes(value);
      if (isSelected) {
        onChange(selectedValues.filter(item => item !== value));
      } else {
        onChange([...selectedValues, value]);
      }
    };
    $[3] = onChange;
    $[4] = selectedValues;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSelection = t4;
  let t5;
  if ($[6] !== filterType) {
    t5 = value_0 => {
      switch (filterType) {
        case "cylinder":
          {
            return value_0.split(" ")[0] || "";
          }
        case "driveType":
          {
            const driveTrain = value_0.split(" ");
            if (driveTrain.length === 3) {
              if (driveTrain[0] === "Four") {
                return "4" + (driveTrain[1]?.[0] || "") + (driveTrain[2]?.[0] || "");
              } else {
                return (driveTrain[0]?.[0] || "") + (driveTrain[1]?.[0] || "") + (driveTrain[2]?.[0] || "");
              }
            } else {
              if (driveTrain.length === 1) {
                return value_0;
              }
            }
            return value_0;
          }
        case "engine":
          {
            return value_0 !== "Other" ? value_0 + "L" : value_0;
          }
        default:
          {
            return value_0;
          }
      }
    };
    $[6] = filterType;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const renderValue = t5;
  const selectedCount = selectedValues.length;
  let t6;
  if ($[8] !== title) {
    t6 = <span>{title}</span>;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = isOpen ? faAngleUp : faAngleDown;
  let t8;
  if ($[10] !== t7) {
    t8 = <FontAwesomeIcon icon={t7} className="t-h-4 t-w-4 t-text-[#928c96]" aria-hidden="true" />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isOpen || $[13] !== onToggle || $[14] !== optionsId || $[15] !== t6 || $[16] !== t8 || $[17] !== triggerId) {
    t9 = <button id={triggerId} className="t-flex t-w-full t-items-center t-justify-between t-text-left t-text-sm t-font-extrabold t-text-[#38323d] t-transition-colors hover:t-text-brand-violet focus:t-rounded-none focus:t-outline-none focus:t-ring-2 focus:t-ring-brand-violet focus:t-ring-offset-2" type="button" onClick={onToggle} aria-expanded={isOpen} aria-controls={optionsId}>{t6}{t8}</button>;
    $[12] = isOpen;
    $[13] = onToggle;
    $[14] = optionsId;
    $[15] = t6;
    $[16] = t8;
    $[17] = triggerId;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== onClear || $[20] !== selectedCount) {
    t10 = selectedCount > 0 && <div className="t-mt-2"><ClearButton onClear={onClear} count={selectedCount} /></div>;
    $[19] = onClear;
    $[20] = selectedCount;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== handleSelection || $[26] !== isOpen || $[27] !== options || $[28] !== optionsId || $[29] !== renderValue || $[30] !== selectedValues || $[31] !== triggerId) {
    t12 = isOpen && options && <div id={optionsId} className="t-mt-4" role="group" aria-labelledby={triggerId}><div className="t-grid t-gap-1">{options.map((option, index) => {
          const isSelected_0 = selectedValues.includes(option);
          const displayValue = renderValue(option);
          return <button type="button" key={index} className={`t-flex t-items-center t-gap-2.5 t-rounded-none t-px-1 t-py-2 t-text-left t-text-[13px] t-font-medium t-transition-colors t-duration-200 ${isSelected_0 ? "t-bg-[#f7f3ff] t-text-brand-violet-dark" : "t-bg-white t-text-[#5e5864] hover:t-bg-[#faf9fb]"}`} onClick={() => handleSelection(option)} aria-pressed={isSelected_0} aria-label={`${displayValue} ${isSelected_0 ? "selected" : "not selected"}`}><span className={`t-flex t-h-4 t-w-4 t-flex-shrink-0 t-items-center t-justify-center t-rounded t-border ${isSelected_0 ? "t-border-brand-violet t-bg-brand-violet t-text-white" : "t-border-[#cfcad2] t-bg-white"}`} aria-hidden="true">{isSelected_0 && <span className="t-text-[10px] t-font-black">✓</span>}</span><span>{displayValue}</span></button>;
        })}</div></div>;
    $[25] = handleSelection;
    $[26] = isOpen;
    $[27] = options;
    $[28] = optionsId;
    $[29] = renderValue;
    $[30] = selectedValues;
    $[31] = triggerId;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== ariaLabel || $[37] !== className || $[38] !== t13) {
    t14 = <div className={className} aria-label={ariaLabel}>{t13}</div>;
    $[36] = ariaLabel;
    $[37] = className;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};